import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../App.css';

const AdminLayout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  
  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <div className="admin-layout">
      <header className="admin-header">
        <div className="logo-container">
          <Link to="/admin/dashboard">
            <h1>Platform Invest <span className="text-primary">2.0</span></h1>
          </Link>
        </div>
        
        <div className="mobile-menu-toggle" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        
        <nav className={`admin-nav ${menuOpen ? 'open' : ''}`}>
          <ul>
            <li className={location.pathname.includes('/admin/dashboard') ? 'active' : ''}>
              <Link to="/admin/dashboard">Dashboard</Link>
            </li>
            <li className={location.pathname.includes('/admin/users') ? 'active' : ''}>
              <Link to="/admin/users">Usuários</Link>
            </li>
            <li className={location.pathname.includes('/admin/investments') ? 'active' : ''}>
              <Link to="/admin/investments">Investimentos</Link>
            </li>
            <li className={location.pathname.includes('/admin/documentation') ? 'active' : ''}>
              <Link to="/admin/documentation">Documentação</Link>
            </li>
            <li className={location.pathname.includes('/admin/settings') ? 'active' : ''}>
              <Link to="/admin/settings">Configurações</Link>
            </li>
            <li>
              <button onClick={logout} className="logout-button">Sair</button>
            </li>
          </ul>
        </nav>
      </header>
      
      <main className="admin-content">
        {children}
      </main>
      
      <footer className="admin-footer">
        <p>&copy; {new Date().getFullYear()} Platform Invest 2.0 - Todos os direitos reservados</p>
      </footer>
    </div>
  );
};

export default AdminLayout; 